export enum LoginStatus {
  ANONYMOUS = 'anonym',
  LOADING = 'loading',
  INITIALIZING = 'initializing',
  AUTHENTICATED = 'authenticated',
}
